import { render } from "./AcknowledgeInfo.vue?vue&type=template&id=f176525c&ts=true"
import script from "./AcknowledgeInfo.vue?vue&type=script&lang=ts"
export * from "./AcknowledgeInfo.vue?vue&type=script&lang=ts"

import "./AcknowledgeInfo.vue?vue&type=style&index=0&id=f176525c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__